module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5J9X8"))).then(() => parcelRequire('37nVf'));